import React from "react"

import { graphql, useStaticQuery } from "gatsby"

import Layout from "../components/layout"
import Head from "../components/head"

export default () => {
  const data = useStaticQuery(graphql`
    query {
        site {
            siteMetadata {
              owner
              mailCompany
              nameCompany
              streetCompany
              cityCompany
            }
        }
    }  
  `)

  return (
    <div>
      <Layout>
        <Head title = "Imprint"/>

        {/* An JSX comment 
        */}

        <h1>Imprint</h1>

        <h2>Company</h2>
          <p>
            {data.site.siteMetadata.nameCompany}<br />
            {data.site.siteMetadata.streetCompany}<br />
            {data.site.siteMetadata.cityCompany}<br />
          </p>

        <h2>Authorized representative managing director</h2>
          <p>
            {data.site.siteMetadata.owner}
          </p>

        <h2>E-Mail</h2>
          <p>
            {data.site.siteMetadata.mailCompany}
          </p>
          
        <h2>Registration Court</h2>
          <p>
            Amtsgericht Dortmund
          </p>

        <h2>Registration number</h2>
          <p>
            HRB 25284
          </p>

        <h2>Sales tax identification number according to § 27a UStG</h2>
          <p>
            DE 340/5727/4817
          </p>
        
        <h2>Responsible for the content</h2>
          <p>
            {data.site.siteMetadata.owner} (address as given above)
          </p>
      </Layout>
    </div>  
  )
}
